import axios from 'axios'
import router from '@/router'

export default {
  /**
   * Get all parking fines
   * @return {Array} - array of parking fines
   */
  getParkingFines({ commit, dispatch, rootState }, queryString) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getParkingFines', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/parking-fines?${queryString}`,
          config
        )
        .then(response => {
          const parkingFines = response.data
          commit('setParkingFines', parkingFines)
          resolve(response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getParkingFines', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  getParkingStatusCheckLogs({ commit, dispatch, rootState }, queryString) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getParkingStatusCheckLogs', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/enforcement/parking-status-check-logs?${queryString}`,
          config
        )
        .then(response => {
          const parkingStatusCheckLogs = response.data
          commit('setParkingStatusCheckLogs', parkingStatusCheckLogs)
          resolve(response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getParkingStatusCheckLogs', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  /**
   * Get image of parking fine
   * @param {Number} - parking fine id
   * @return {Array} - array of images
   */
  getParkingFineImages({ commit, dispatch, rootState }, id) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getParkingFineImages', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/parking-fines/${id}/images`,
          config
        )
        .then(response => {
          const parkingFineImages = response.data
          commit('setParkingFineImages', parkingFineImages)
          resolve(parkingFineImages)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getParkingFineImages', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  /**
   * Put parking fine
   * @param {Object} - parking fine
   * @return {Array} - array of images
   */
  async putParkingFine({ commit, dispatch, rootState }, parkingFine) {
    commit(
      'app/setLoading',
      { type: 'putParkingFine', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .put(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/${parkingFine.id}`,
        parkingFine,
        config
      )
      .then(response => {
        commit('setParkingFineInParkingFinesArray', response.data)
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
        dispatch('getParkingFine', parkingFine.id)
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setLoading',
          { type: 'putParkingFine', state: false },
          { root: true }
        )
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: `Something went wrong! Please try again later.`
          },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },

  /**
   * Patch parking fine
   * @param {Object} - { id, hasSentAppeal }
   */
  async patchParkingFine({ commit, dispatch, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'patchParkingFine', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .patch(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/${payload.id}`,
        { hasSentAppeal: payload.hasSentAppeal },
        config
      )
      .then(() => {
        commit('setSelectedParkingFineSpecificKeyValue', {
          key: 'hasSentAppeal',
          value: payload.hasSentAppeal
        })
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setLoading',
          { type: 'patchParkingFine', state: false },
          { root: true }
        )
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: `Something went wrong! Please try again later.`
          },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },

  /**
   * Post parking fine debt income
   * @param {Object} - {id, paidAmount, dateReceived}
   */
  async markParkingFineIncome({ commit, dispatch, rootState }, parkingFine) {
    commit(
      'app/setLoading',
      { type: 'markParkingFineIncome', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .post(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/${parkingFine.id}/income`,
        parkingFine,
        config
      )
      .then(() => {
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setLoading',
          { type: 'markParkingFineIncome', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Get parking fine debt incomes
   * @param {Object} - {id, paidAmount, dateReceived}
   */
  async getParkingFineDebtIncomes(
    { commit, dispatch, rootState },
    parkingFineId
  ) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'markParkingFineIncome', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }

      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/parking-fines/${parkingFineId}/incomes`,
          config
        )
        .then(response => {
          const parkingFines = response.data
          resolve(parkingFines)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getParkingFines', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  /**
   * Get parking fing credit bill pdf
   * @param {Number} - parking fine id
   * @return {Array} - pdf bytes
   */
  getParkingFineInvoicePDF({ commit, dispatch, rootState }, invoice) {
    commit(
      'app/setLoading',
      { type: 'getParkingFineInvoicePDF', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    axios
      .get(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/invoices/${invoice.id}/pdf`,
        config
      )
      .then(response => {
        const parkingFineCreditBillPdf = response.data
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
        const linkSource = `data:application/pdf;base64,${parkingFineCreditBillPdf.pdfBytes}`
        const downloadLink = document.createElement('a')
        const fileName = `parking-fine-${invoice.invoiceNumber}.pdf`
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setLoading',
          { type: 'getParkingFineInvoicePDF', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Get parking fine
   * @param {Number} - parking fine id
   * @return {Array} - array of parking fines
   */
  getParkingFine({ commit, dispatch, rootState }, fineId) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getParkingFine', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/parking-fines/${fineId}`,
          config
        )
        .then(response => {
          const parkingFine = response.data
          commit('setSelectedParkingFine', parkingFine)
          resolve(response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getParkingFine', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  /**
   * Put parking fine
   * @param {Object} - parking fine
   * @return {Array} - array of images
   */
  async sendParkingFineToJulianus(
    { commit, dispatch, rootState },
    parkingFine
  ) {
    commit(
      'app/setLoading',
      { type: 'sendParkingFineToJulianus', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .post(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/${parkingFine.id}/send-to-julianus`,
        parkingFine,
        config
      )
      .then(response => {
        commit('setParkingFineInParkingFinesArray', response.data)
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
        dispatch('getParkingFine', parkingFine.id)
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setLoading',
          { type: 'sendParkingFineToJulianus', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Reset parking fine to initial state
   * @param {Object} - parking fine
   * @return {Object} - parkingFine
   */
  async resetParkingFine({ commit, dispatch, rootState }, parkingFine) {
    commit(
      'app/setLoading',
      { type: 'resetParkingFine', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .post(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/${parkingFine.id}/reset`,
        null,
        config
      )
      .then(async response => {
        await dispatch('getParkingFine', response.data.id)
        commit(
          'setParkingFineInParkingFinesArray',
          rootState.enforcement.selectedParkingFine
        )
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        if (error.response.status && error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setLoading',
          { type: 'resetParkingFine', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message:
              error.response && error.response.data
                ? error.response.data.Error
                : `Something went wrong! Please try again later.`
          },
          { root: true }
        )
      })
  },
  /**
   * Get parking fine debt incomes
   * @param {Object} - {id, paidAmount, dateReceived}
   */
  async getParkingFineReasons({ commit, dispatch, rootState }) {
    commit(
      'app/setLoading',
      { type: 'getParkingFineReasons', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }

    axios
      .get(
        `${process.env.VUE_APP_URL}/adminapi/parking-fine-reasons?language=EST&type=REASON`,
        config
      )
      .then(response => {
        commit('setAvailableReasons', response.data)
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setLoading',
          { type: 'getParkingFineReasons', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Put parking fine's DoNotForwardDebts value
   */
  async putDoNotForwardDebtsValue({ commit, dispatch, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'putDoNotForwardDebtsValue', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .put(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/${payload.parkingFineId}/do-not-forward-debts`,
        { doNotForwardDebts: payload.doNotForwardDebts },
        config
      )
      .then(() => {
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: payload.this.$vuetify.lang.t(
              `$vuetify.ENFORCEMENT.PARKING_FINE_UPDATED_SUCCESSFULLY`
            )
          },
          { root: true }
        )
      })
      .catch(error => {
        commit(
          'app/setLoading',
          { type: 'putDoNotForwardDebtsValue', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
        dispatch('getParkingFine', payload.parkingFineId)
      })
  },
  /**
   * Put parking fine's ForwardDebtsAt value
   */
  async putForwardDebtsAtValue({ commit, dispatch, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'putForwardDebtsAtValue', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .put(
        `${process.env.VUE_APP_URL}/adminapi/parking-fines/${payload.parkingFineId}/forward-debts-at`,
        { forwardDebtsAt: payload.forwardDebtsAt },
        config
      )
      .then(() => {
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: payload.this.$vuetify.lang.t(
              `$vuetify.ENFORCEMENT.PARKING_FINE_UPDATED_SUCCESSFULLY`
            )
          },
          { root: true }
        )
      })
      .catch(error => {
        commit(
          'app/setLoading',
          { type: 'putForwardDebtsAtValue', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })

        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: error.response.data
              ? error.response.data.Error
              : 'Something went wrong! Please try again later.'
          },
          { root: true }
        )
        dispatch('getParkingFine', payload.parkingFineId)
      })
  },
  /**
   * Put a place's penalty appeal comments, shown next to every parking fine of that place
   */
  async putPlacePenaltyAppealComments(
    { commit, dispatch, rootState },
    payload
  ) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'putPlacePenaltyAppealComments', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/places/${payload.placeId}/penalty-appeal-comments`,
          { penaltyAppealComments: payload.penaltyAppealComments },
          config
        )
        .then(() => {
          commit('setPenaltyAppealCommentsForPlace', payload)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve()
        })
        .catch(error => {
          if (error && error.response && error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'putPlacePenaltyAppealComments', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async getParkingFineReportingTasks({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getParkingFineReportingTasks', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/parking-fine/reporting-tasks`,
          config
        )
        .then(response => {
          commit('setParkingFineReportingTasks', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(response.data)
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getParkingFineReportingTasks', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async postParkingFineReportingTask({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postParkingFineReportingTask', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/parking-fine/reporting-tasks`,
          payload,
          config
        )
        .then(response => {
          commit('addParkingFineReportingTask', response.data)
          commit(
            'vehicleGroups/addVehicleGroupItem',
            {
              ID: response.data.vehicleGroupId,
              name: response.data.vehicleGroupName
            },
            { root: true }
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve()
        })
        .catch(error => {
          if (error && error.response && error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'postParkingFineReportingTask', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async putParkingFineReportingTask({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'putParkingFineReportingTask', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/parking-fine/reporting-tasks`,
          payload,
          config
        )
        .then(response => {
          commit(
            'setParkingFineReportingTaskInParkingFineReportingTasksArray',
            response.data
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(response.data)
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'putParkingFineReportingTask', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async deleteParkingFineReportingTask({ commit, dispatch, rootState }, id) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'deleteParkingFineReportingTask', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/parking-fine/reporting-tasks/delete`,
          { ID: id },
          config
        )
        .then(() => {
          commit('removeParkingFineReportingTaskByID', id)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve()
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'deleteParkingFineReportingTask', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async getEnforcementOfficers({ commit, dispatch, rootState }, queryString) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getEnforcementOfficers', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/enforcement/officers${queryString}`,
          config
        )
        .then(response => {
          const enforcementOfficers = response.data
          commit('setEnforcementOfficers', enforcementOfficers)
          resolve(response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getEnforcementOfficers', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async saveEnforcementOfficer(
    { commit, dispatch, rootState },
    autoGeneratePassword
  ) {
    commit(
      'app/setLoading',
      { type: 'postEnforcementOfficer', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }

    if (
      !rootState.enforcement.selectedEnforcementOfficer.ID ||
      rootState.enforcement.selectedEnforcementOfficer.ID <= 0
    ) {
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/enforcement/officers`,
          {
            ...rootState.enforcement.selectedEnforcementOfficer,
            autoGeneratePassword
          },
          config
        )
        .then(resp => {
          commit('addEnforcementOfficer', resp.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'postEnforcementOfficer', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
        })
    } else {
      await axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/enforcement/officers`,
          {
            ...rootState.enforcement.selectedEnforcementOfficer
          },
          config
        )
        .then(resp => {
          commit('setEnforcementOfficerInEnforcementOfficersArray', resp.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'postEnforcementOfficer', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
        })
    }
  },
  async deleteEnforcementOfficer({ commit, dispatch, rootState }, id) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'deleteEnforcementOfficer', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/enforcement/officers/${id}/delete`,
          { ID: id },
          config
        )
        .then(() => {
          commit('removeEnforcementOfficerByID', id)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve()
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'deleteEnforcementOfficer', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async getEnforcementPlaceGroups({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getEnforcementPlaceGroups', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/enforcement/enforcement-place-groups`,
          config
        )
        .then(response => {
          const enforcementPlaceGroups = response.data
          commit('setEnforcementPlaceGroups', enforcementPlaceGroups)
          resolve(response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getEnforcementPlaceGroups', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  async inviteEnforcementOfficer({ commit, dispatch, rootState }, id) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'inviteEnforcementOfficer', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/enforcement/officers/${id}/invite`,
          null,
          config
        )
        .then(() => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'Invitation send out successfully!'
            },
            { root: true }
          )
          resolve()
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'inviteEnforcementOfficer', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  setNewPassword: async ({ commit }, payload) => {
    commit(
      'app/setLoading',
      { type: 'setNewPassword', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    try {
      axios
        .post(
          `${process.env.VUE_APP_URL}/admin/password/reset?forEnforcementOfficer=true`,
          {
            uuid: payload.uuid,
            ps1: payload.ps1,
            ps2: payload.ps2
          }
        )
        .then(response => {
          if (!response.data.Error && response.data.Success) {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: payload.this.$vuetify.lang.t(
                  router.currentRoute.name === 'reset'
                    ? '$vuetify.PASSWORD_CHANGED_SUCCESSFULLY'
                    : '$vuetify.ACCOUNT_ACTIVATED_SUCCESSFULLY'
                )
              },
              { root: true }
            )
            router.replace({ path: '/login' })
          } else {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: response.data.Message
              },
              { root: true }
            )
          }
        })
        .catch(err => {
          if (err.response) {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: err.response.data.Error
              },
              { root: true }
            )
          } else {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'error',
                message: payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
              },
              { root: true }
            )
          }
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'setNewPassword', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  }
}
